/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DtmDocsEditCheckCreateRequest = {} | null | undefined;
export type DtmDocsEditCheckCreateResponse = any;

export type DtmDocsEditCheckCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/dtm_docs/{id}/edit_check/
 *
 * ```yaml
 * operationId: dtm_docs_edit_check_create
 * tags:
 *   - dtm_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dtmDocsEditCheckCreateOperation = ({ id, ...rest }: DtmDocsEditCheckCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/dtm_docs/${id}/edit_check/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dtm_docs/{id}/edit_check/' };
  };

/**
 * POST /dmx-server/dtm_docs/{id}/edit_check/
 *
 * ```yaml
 * operationId: dtm_docs_edit_check_create
 * tags:
 *   - dtm_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dtmDocsEditCheckCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DtmDocsEditCheckCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dtmDocsEditCheckCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
